import { useEffect, useState } from 'react'
import { api, type audit_entry } from '../api'
import { format_timestamp } from '../format'

const action_label: Record<string, string> = {
  admin_login: 'Admin angemeldet',
  admin_login_failed: 'Fehlgeschlagene Anmeldung',
  user_created: 'Benutzer angelegt',
  user_updated: 'Benutzer geändert',
  user_deleted: 'Benutzer gelöscht',
  import_committed: 'Import übernommen',
  import_reverted: 'Import zurückgenommen',
  receipt_required_set: 'Belegpflicht gesetzt',
  receipt_required_cleared: 'Belegpflicht entfernt',
  receipt_uploaded: 'Beleg hochgeladen',
  receipt_deleted: 'Beleg gelöscht',
  payment_accepted: 'Zahlung angenommen',
  payment_rejected: 'Zahlung abgelehnt',
  payment_acceptance_revoked: 'Annahme zurückgenommen',
  reminder_sent: 'Erinnerung versendet',
  reminder_sent_manually: 'Erinnerung manuell versendet',
  reminder_failed: 'Erinnerung fehlgeschlagen',
  reminder_job_finished: 'Erinnerungslauf beendet',
  rejection_mail_sent: 'Ablehnungsmail versendet',
  admin_digest_sent: 'Tageszusammenfassung versendet',
}

/**
 * Nur der Admin sieht das Protokoll. Es ist der einzige Nachweis bei "ich habe
 * das doch hochgeladen" oder "ich habe nie eine Mail bekommen".
 */
export function AuditPage() {
  const [entries, set_entries] = useState<audit_entry[]>([])

  useEffect(() => {
    void api.list_audit().then(set_entries)
  }, [])

  return (
    <div className="page">
      <h1>Protokoll</h1>
      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Zeitpunkt</th>
              <th>Wer</th>
              <th>Was</th>
              <th>Bezug</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td className="small" style={{ whiteSpace: 'nowrap' }}>
                  {format_timestamp(entry.occurred_at)}
                </td>
                <td className="small">
                  {entry.actor_label}
                  <div className="muted">{entry.actor_type}</div>
                </td>
                <td>{action_label[entry.action] ?? entry.action}</td>
                <td className="small muted">
                  {entry.subject_type ? `${entry.subject_type} #${entry.subject_id}` : '—'}
                </td>
                <td className="small muted">
                  {Object.keys(entry.detail).length > 0 ? JSON.stringify(entry.detail) : '—'}
                </td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">
                  Noch keine Einträge.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
